import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import apiService from "services/api";
import { queryKeys } from "./queries";
import { useNotificationContext } from "contexts";

const useAddCourseConfidenceForm = () =>
	useForm({
		defaultValues: {
			courseId: undefined,
			confidenceLevel: undefined,
			lessonId: undefined,
		},
	});

const useMutateCourseConfidence = (props) => {
	const { createNotification } = useNotificationContext();
	const queryClient = useQueryClient();
	return useMutation(
		(validatedFormValues) =>
			props?.type && props.type === "edit"
				? apiService.staff.courseConfidence.update(props.courseId, validatedFormValues)
				: apiService.staff.courseConfidence.create(validatedFormValues),
		{
			onSuccess: () => {
				queryClient.invalidateQueries(queryKeys.STAFF_COURSES);
				props?.onSuccess && props.onSuccess();
				createNotification({ type: "success", message: "Record successfully added" });
			},
			onError: (error) => {
				createNotification({ type: "danger", message: error?.message });
			},
		}
	);
};

const useDeleteCourseConfidence = (courseConfidenceToDeleteId, onSuccess) => {
	const { createNotification } = useNotificationContext();
	const queryClient = useQueryClient();
	return useMutation(() => apiService.staff.courseConfidence.delete(courseConfidenceToDeleteId), {
		onSuccess: () => {
			queryClient.invalidateQueries(queryKeys.STAFF_COURSES);
			onSuccess && onSuccess();
			createNotification({ type: "success", message: "Course lesson confidence successfully deleted" });
		},
	});
};

export { useAddCourseConfidenceForm, useMutateCourseConfidence, useDeleteCourseConfidence };
